module.exports = function (analytics) {
    return {
        scope: {
            erCategory: '@',
            erValue: '@?',
            erLabel: '@',
            erTriggerKeyCode: '@?',
        },
        restrict: 'A',
        link: (scope, elem, attr) => {
            const eventAction = attr.wowEventRecorder;
            const getEventData = function () {
                return {
                    category: scope.erCategory || '',
                    value: scope.erValue || '',
                    label: scope.erLabel || '',
                };
            };

            elem.bind(eventAction, (evt) => {

                if (scope.erTriggerKeyCode && evt.which !== parseInt(scope.erTriggerKeyCode)) {
                    return;
                }

                analytics.push({
                    data: {
                        event: getEventData(),
                        trackingType: 'link',
                    },
                    type: analytics.mapperTypes.customEvent.customEvent,
                });

            });

        },
    };
};



// WEBPACK FOOTER //
// ./src/common/eventrecorder/event-recorder.directive.js